import React from "react";
import LineHaulFilterContextProvider from "../linehaul/context/LineHaulFilterContext";
import CapabilityContextProvider from "../global/context/ConfigContext";
import InductFilterContextProvider from "./context/InductFilterContext";
import Column from "@amzn/meridian/column";
import Navigation, {NavigationRoutes} from "../util/Navigation";
import {INDUCT_ROUTES} from "../util/RouteConstants";
import InductOverviewContextProvider from "./context/InductOverviewContext";
import InductAreaContextProvider from "./context/InductAreaContext";
import ContainerContextProvider from "./context/ContainerContext";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS as PAGE_HEADER} from "../util/Constants";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const Induct = ({location, history}) => {
    const {spacingInset_shorthand2} = useDeviceLayout();
    return (
        <Column spacingInset={spacingInset_shorthand2} spacing={"medium"}>
            <PageHeader {...PAGE_HEADER.INDUCT}/>
            <InductOverviewContextProvider>
            <InductAreaContextProvider>
            <ContainerContextProvider>
            <Navigation routes={INDUCT_ROUTES} location={location} history={history}/>
            <LineHaulFilterContextProvider>
            <InductFilterContextProvider>
                <CapabilityContextProvider>
                    <NavigationRoutes routes={INDUCT_ROUTES}/>
                </CapabilityContextProvider>
            </InductFilterContextProvider>
            </LineHaulFilterContextProvider>
            </ContainerContextProvider>
            </InductAreaContextProvider>
            </InductOverviewContextProvider>
        </Column>
    )
}

export default Induct


// WEBPACK FOOTER //
// ./src/components/induct/Induct.js